export interface WeekdaysSelectProps {
  selected: any[];
  onSelect: (...args: any[]) => any;
  multiple?: boolean;
  currentLocale?: string;
}
